export class StringIdGenerator {
  _chars: string
  _nextId: number[]
  constructor(chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') {
    this._chars = chars;
    this._nextId = [0];
  }

  next() {
    const r = [];
    for (const char of this._nextId) {
      r.unshift(this._chars[char]);
    }
    this._increment();
    return r.join('');
  }

  backIndex() {
    this._nextId[this._nextId.length-1] -= 1
  }

  changeNextId(currentChar) {
    for (let i = 0; i < this._chars.length; i++) {
      if (currentChar === this._chars[i]) {
        this._nextId = [i+1]
      }
    }
  }

  _increment() {
    for (let i = 0; i < this._nextId.length; i++) {
      const val = ++this._nextId[i];
      if (val >= this._chars.length) {
        this._nextId[i] = 0;
      } else {
        return;
      }
    }
    this._nextId.push(0);
  }

  *[Symbol.iterator]() {
    while (true) {
      yield this.next();
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/StringIdGenerator.ts